import FlagIcon from '@mui/icons-material/Flag';
import { CriticalResultsModal } from './CriticalResultsModal';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { PermissionName } from '@sironamedical/common';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';

type FlagCriticalResultModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  worklistItemSmid: string;
  onSubmit: () => Promise<void>;
};

export const FlagCriticalResultModal = ({
  worklistItemSmid,
  isOpen,
  setIsOpen,
  onSubmit,
}: FlagCriticalResultModalProps) => {
  const hasWriteAccess = useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.ExamCommentReadWriteAccess],
  });

  return (
    <CriticalResultsModal
      worklistItemSmid={worklistItemSmid}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Flag Critical Result"
      titleIcon={
        <FlagIcon
          style={{
            height: '24px',
            width: '24px',
          }}
        />
      }
      body={
        <Stack vertical css="margin-top: 8px">
          <Text>
            You are marking this result as <b>critical</b> and requiring attention. This action will
            be recorded in the case history.
          </Text>
          {hasWriteAccess && (
            <Text css="margin-top: 12px">
              Add an optional comment to provide additional context.
            </Text>
          )}
        </Stack>
      }
      actionLabel="Flag result"
      onSubmit={onSubmit}
    />
  );
};
